export default "__VITE_ASSET__DRYWMmlY__"